import { FlagAmountAxis } from '@generated/graphql';
import { formatThresholdCentsAsDollars } from '@ovComponents/5-page/settings/flagPolicies/utils/flagPolicy';

export const GLOSSARY_THRESHOLD_EMPTY = '—';

type GlossaryPolicyValues = {
  thresholdCents?: number | null;
  percentThreshold?: number | null;
};

export const formatGlossaryThreshold = (
  values: GlossaryPolicyValues,
  axis: FlagAmountAxis | null | undefined,
  isAmountThresholdable: boolean,
): string => {
  if (!isAmountThresholdable) {
    return GLOSSARY_THRESHOLD_EMPTY;
  }

  if (axis === FlagAmountAxis.Cents && values.thresholdCents != null) {
    return `$${formatThresholdCentsAsDollars(values.thresholdCents)}`;
  }

  if (axis === FlagAmountAxis.PercentOnly && values.percentThreshold != null) {
    return `${values.percentThreshold}%`;
  }

  return GLOSSARY_THRESHOLD_EMPTY;
};
